import { SalesContractList } from "@/components/sales-contracts/sales-contract-list";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_dashboard/sales-contracts")({
	component: SalesContractsPage,
});

function SalesContractsPage() {
	return (
		<div className="container mx-auto px-4 py-6">
			<SalesContractList />
		</div>
	);
}
